import { z } from "zod";

export const blogSchema = z.object({
  id: z.string(),
  title: z.string(),
  content: z.string(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});

export const blogFormSchema = blogSchema.pick({
  title: true,
  content: true,
});
